const browserDetect = {
  isIPad: false,
  isIPhone: false,
  isIPod: false,
  isIPhoneOrIPod: false,
  isIPhoneOrIPodOrIPad: false,
  isAndroid: false,
  isIE9: false,
  isIE10: false,
  isIE11: false,
  isIE: false,
  isEdge: false,
  isEdgeOrIE: false,
  isSafari: false,
  isTouch: false,
};
if (/iPad/i.test(navigator.userAgent)) {
  browserDetect.isIPad = true;
}
if (/iPhone/i.test(navigator.userAgent)) {
  browserDetect.isIPhone = true;
}
if (/iPod/i.test(navigator.userAgent)) {
  browserDetect.isIPod = true;
}
if (browserDetect.isIPhone || browserDetect.isIPod) {
  browserDetect.isIPhoneOrIPod = true;
}
if (browserDetect.isIPhone || browserDetect.isIPod || browserDetect.isIPad) {
  browserDetect.isIPhoneOrIPodOrIPad = true;
}
if (/Android/i.test(navigator.userAgent)) {
  browserDetect.isAndroid = true;
}
if (/MSIE 9/i.test(navigator.userAgent)) {
  browserDetect.isIE9 = true;
}
if (/MSIE 10/i.test(navigator.userAgent)) {
  browserDetect.isIE10 = true;
}
if (/rv:11.0/i.test(navigator.userAgent)) {
  browserDetect.isIE11 = true;
}
if (browserDetect.isIE9 || browserDetect.isIE10 || browserDetect.isIE11) {
  browserDetect.isIE = true;
}
if (/Edge\/\d./i.test(navigator.userAgent)) {
  browserDetect.isEdge = true;
}
if (/^((?!chrome|android).)*safari/i.test(navigator.userAgent.toLowerCase())) {
  browserDetect.isSafari = true;
}
if (/^((?!chrome|android).)*safari/i.test(navigator.userAgent.toLowerCase())) {
  browserDetect.isSafari = true;
}
if (browserDetect.isEdge || browserDetect.isIE) {
  browserDetect.isEdgeOrIE = true;
}
function isTouchDevice () {
  const prefixes = ' -webkit- -moz- -o- -ms- '.split(' ');
  const mq = (query) => window.matchMedia(query).matches;
  if (('ontouchstart' in window) || (window.DocumentTouch && document instanceof window.DocumentTouch)) {
    return true;
  }
  const query = ['(', prefixes.join('touch-enabled),('), 'heartz', ')'].join('');
  return mq(query);
}
if (isTouchDevice()) {
  browserDetect.isTouch = true;
}
browserDetect.addGlobalClasses = () => {
  Object.keys(browserDetect).forEach((prop) => {
    if (browserDetect[prop] === true) {
      document.documentElement.classList.add(prop);
    }
  });
};

export default browserDetect;



// WEBPACK FOOTER //
// ./custom_dependencies/brandhub-embxp-frontend/daimler-brandhub-modules/daimler-brandhub-design/daimler-brandhub-design-package/frontend/src/common/js/browserdetect/browserdetect.js